export const QUANTITY_ON_HAND_ERROR =
  "Quantity on hand must be a whole number of 0 or more.";

export const MINIMUM_ORDER_ERROR =
  "Minimum order must be a whole number of at least 1.";

export function quantityOnHandError(quantityAvailable: number): string | null {
  return Number.isSafeInteger(quantityAvailable) && quantityAvailable >= 0
    ? null
    : QUANTITY_ON_HAND_ERROR;
}

export function minimumOrderError(
  minOrderQuantity: number,
  quantityAvailable: number,
): string | null {
  if (!Number.isSafeInteger(minOrderQuantity) || minOrderQuantity < 1) {
    return MINIMUM_ORDER_ERROR;
  }
  if (quantityAvailable > 0 && minOrderQuantity > quantityAvailable) {
    return `Minimum order cannot be more than the ${quantityAvailable.toLocaleString("en-US")} units on hand.`;
  }
  return null;
}
